import { IconCompleteSolid, Text } from "@instructure/ui";
import { useTranslation } from "react-i18next";

const SuccessBody = () => {
  const { t } = useTranslation();

  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ marginBottom: "1.5rem" }}>
        <IconCompleteSolid color="success" size="medium" />
      </div>
      <Text size="medium" as="p" weight="bold" color="primary">
        {t("finalizeCourse.successBody")}
      </Text>
    </div>
  );
};

export default SuccessBody;
